<template>
  <div :class="$style['pt-adult-stock-list']" v-loading="loading">
    <pt-page-title title="库存管理"  :isSearch="true" @search="search" @emptySearch="emptySearch" :searchKey="searchKey">
      <el-button slot="before-left" type="primary" @click="goOut">样本出库</el-button>
    </pt-page-title>
    <pt-page-factor-filter :labels="filterLabels" isQueryRouter v-model="filterForm" @Filter="Filter" ref="filter">
      <el-button type="primary" @click="handleFilter(currentStatusFilter,true)">筛选</el-button>
    </pt-page-factor-filter>
    <!-- tabs -->
    <el-tabs v-model="currentStatusFilter" @tab-click="handleClick" slot="title">
      <el-tab-pane label="当前库存" name="in"></el-tab-pane>
      <el-tab-pane label="已出库" name='out'></el-tab-pane>
			<el-tab-pane label="全部生产记录" name='ALL'></el-tab-pane>
    </el-tabs>
    <!-- 表格 -->
    <pt-adult-stock-table :tableLabels="currentTableLabels" :status="currentStatusFilter" ref="table" :isFuzzy="isFuzzy">
      <template>
        <el-table-column label="状态" prop="inStore">
          <template slot-scope="scope">
            {{scope.row.inStore ? '在库' :'已出库' }}
          </template>
        </el-table-column>
      </template>
    </pt-adult-stock-table>
  </div>
</template>

<script>
import { filterFactor } from '../adult-stock-options'
import ptAdultStockTable from './pt-adult-stock-table/withData'
import { emptyObject } from '@/utils/lifebankUtils'
import { inTableLabels, outTableLabels, ALLTableLabels } from 'cps/adult-stocks-manage/adult-stock-options'
// 组件class前缀
const prefixCls = 'pt-adult-stock-list'

export default {
  name: 'pt-adult-stock-list',
  props: {
    agentOrgs: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    currentTableLabels () {
      let res = `${this.currentStatusFilter}TableLabels`
      return this[res]
    }
  },
  components: {
    ptAdultStockTable
  },
  watch: {
    agentOrgs: {
      handler: function (val, old) {
        this.filterLabels.forEach(item => {
          if (item.value === 'clientInfoId') {
            item.options = val
          }
        })
      },
      immediate: true,
      deep: true
    }
  },
  data () {
    return {
      inTableLabels: inTableLabels,
      outTableLabels: outTableLabels,
      ALLTableLabels: ALLTableLabels,
      loading: false,
      currentStatusFilter: this.$route.params.status,
      filterForm: {},
      searchKey: '',
      isFuzzy: false,
      filterLabels: filterFactor
    }
  },
  methods: {
    goOut () {
      this.$router.push('/adult-out-stock')
    },
    Filter (val) {
      if (!this.searchKey) {
        this.handleFilter(this.currentStatusFilter, true)
      }
    },
    handleClick (tab) {
      this.handleFilter(tab.name)
      this.$router.push({ name: 'adult-stock-list', params: { status: tab.name } })
    },
    handleFilter (tabName, isFuzzy = false) {
      this.isFuzzy = isFuzzy
      if (isFuzzy) {
        if (!this.filterForm.clientInfoId) {
          this.isFuzzy = false
          this.$nextTick(_ => {
            this.$refs.table.reload()
          })
        } else {
          let params = {
            example: {
              clientInfo: {
                id: this.filterForm.clientInfoId
              }
            },
            pageable: { page: 0, size: 20 }
          }
          this.$nextTick(_ => {
            this.$refs.table.reload(params)
          })
        }
      } else {
        this.currentStatusFilter = tabName
      }
    },
    search (val) {
      this.searchKey = val
      this.isFuzzy = true
      emptyObject(this.filterForm)
      this.filterForm.searchKey = val
      this.filterForm.pageable = { page: 0, size: 20 }
      this.$nextTick(_ => {
        this.$refs.table.reload(this.filterForm)
      })
    },
    emptySearch () {
      this.handleFilter(this.$route.params.status)
      this.$nextTick(_ => {
        this.$refs.table.reload(this.filterForm)
      })
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-adult-stock-list {
  :global{
    .el-tabs {
      display: inline-block;
    }
    .el-tabs--top .el-tabs__nav {
      padding-left: 30px;
      padding-right: 30px;
      .el-tabs__item {
        font-size: 16px;
      }
    }
    .el-tabs__active-bar {
      left: 30px;
    }
    .el-button--mini {
      margin-bottom: 10px;
    }
  }
}
</style>
